<template>
  <div class="allsize">
    <div class="leftsize">
      <div class="leftall">
        <div class="lefttop">
          <div class="topone">
            <div class="onetext" :class="{ 'activeen1': isen }">{{ $t('detail.北礵三米测浪浮标') }}</div>
          </div>
          <div class="toptwo">
            <div class="twosquare" style="height:0.6rem;width:1.5rem;">
              <div class="words">{{ $t('detail.经度') }}</div>
              <div class="number">{{ listeqdata['经度'] }}</div>
            </div>
            <div class="twosquare2" style="height:0.6rem;width:1.5rem; margin-left: 0.36rem;">
              <div class="words">{{ $t('detail.纬度') }}</div>
              <div class="number">{{ listeqdata['纬度'] }}</div>
            </div>
          </div>
          <div class="toptwoa">
            <div class="twosquare twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.1/3波高') }}(m)</div>
              <div class="number">{{ Number(listeqdata['1/3波高']).toFixed(1) }}</div>
            </div>
            <div class="twosquare2 twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.1/3波周期') }}(s)</div>
              <div class="number">{{ Number(listeqdata['1/3波周期']).toFixed(1) }}</div>
            </div>
            <div class="twosquare2 twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.1/10波高') }}(m)</div>
              <div class="number">{{ Number(listeqdata['1/10波高']).toFixed(1) }}</div>
            </div>
          </div>
          <div class="toptwoa">
            <div class="twosquare twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.1/10波周期') }}(s)</div>
              <div class="number">{{ Number(listeqdata['1/10波周期']).toFixed(1) }}</div>
            </div>
            <div class="twosquare2 twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.最大波高') }}(m)</div>
              <div class="number">{{ Number(listeqdata['最大波高']).toFixed(1) }}</div>
            </div>
            <div class="twosquare2 twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.最大波周期') }}(s)</div>
              <div class="number">{{ Number(listeqdata['最大波周期']).toFixed(1) }}</div>
            </div>
          </div>
          <div class="toptwoa">
            <div class="twosquare twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.平均波高') }}(m)</div>
              <div class="number">{{ Number(listeqdata['平均波高']).toFixed(1) }}</div>
            </div>
            <div class="twosquare2 twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.平均波周期') }}(s)</div>
              <div class="number">{{ Number(listeqdata['平均波周期']).toFixed(1) }}</div>
            </div>
            <div class="twosquare2 twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.波向') }}(°)</div>
              <div class="number">{{ Number(listeqdata['波向']).toFixed(1) }}</div>
            </div>
          </div>
          <div class="toptwoa">
            <div class="twosquare twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.温度') }}(°C)</div>
              <div class="number">{{ Number(listeqdata['温度']).toFixed(1) }}</div>
            </div>
            <div class="twosquare2 twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.气压') }}(hPa)</div>
              <div class="number">{{ Number(listeqdata['气压(hPa)'] * 1000).toFixed(2) }}</div>
            </div>
            <div class="twosquare2 twosquarehw">
              <div class="words" :class="{ 'activeen2': isen }" >{{ $t('detail.电压值') }}(v)</div>
              <div class="number">{{ Number(listeqdata['电压值']).toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <div id="leftbottom">
          <div id="middleChart3" v-if="showchart"></div>
        </div>
      </div>
    </div>
    <div class="rightsize">
      <div class="righttop">
        <div class="topicon">
          <img class="icon" src="../../public/static/time.png" />
        </div>
        <div class="toptime">{{ $t('detail.时间1') }}</div>
        <div class="block">
          <el-date-picker v-model="value1" value-format="yyyy-MM-dd" type="datetimerange" :unlink-panels="true"
            :range-separator="$t('detail.至')" start-placeholder="开始日期" end-placeholder="结束日期" @change="selectTime">
          </el-date-picker>
        </div>
      </div>
      <div class="rightmiddle">
        <div class="middlenote"></div>
        <!-- <div id="middleChart"
          v-if="showchart"></div> -->
        <div id="middleChart" v-if="showchart"></div>
        <div id="middleChart2" v-if="showchart"></div>
      </div>

      <div class="rightbottom">
        <!-- 修改版 start -->
        <div class="table34">
          <table class="maxdata" cellspacing="0">
            <tr>
              <td class="title24hleft space"  :class="{ 'activeen3': isen }"  style="border-top-left-radius: 0.2rem;">
                {{ $t('detail.24h最大') }}
              </td>
              <td class="title3word space" :class="{ 'activeen3': isen }" >{{ $t('detail.最大风速') }}(m/s)</td>
              <td class="title3word space" :class="{ 'activeen3': isen }" >{{ $t('detail.最大风向') }}(°)</td>
              <td class="title24hleft space" :class="{ 'activeen3': isen }" >{{ $t('detail.24h最大') }}</td>
              <td class="title3word space" :class="{ 'activeen3': isen }" >{{ $t('detail.最大波高') }}(m)</td>
              <td class="title3word space" :class="{ 'activeen3': isen }" >{{ $t('detail.波周期') }}((s)</td>
              <td class="title3word space" :class="{ 'activeen3': isen }" >{{ $t('detail.波向') }}(°)</td>
              <td class="title3word space" :class="{ 'activeen3': isen }" >{{ $t('detail.时间2') }}</td>
            </tr>
            <tr>
              <td class="title24hleft">{{ $t('detail.风速') }}</td>
              <td class="title24h">{{ zdfs }}</td>

              <td class="title24h">{{ zdfx }}</td>
              <td class="title24hleft">{{ $t('detail.波高') }}</td>
              <td class="title24h">{{ zdbg }}</td>
              <td class="title24h">{{ zdbzq }}</td>
              <td class="title24h">{{ zdbx }}</td>
              <td class="title24h">{{ title3time }}</td>
            </tr>
          </table>

          <table border="0" class="table30">
            <tr class="table41 space">
              <td class="table301">{{ $t('detail.最新') }}</td>
              <td class="table301">{{ $t('detail.时间3') }}</td>
              <td class="table301">{{ $t('detail.风速') }}(m/s)</td>
              <td class="table301">{{ $t('detail.风向') }}(°)</td>
              <td class="table301">{{ $t('detail.1/3波高') }}(m)</td>
              <td class="table301">{{ $t('detail.1/3波周期') }}(s)</td>
              <td class="table301">{{ $t('detail.波向') }}(°)</td>
            </tr>
            <tr v-for="(max1, index) in listrev" :key="max1.id" :value="max1">
              <td class="table311">{{ index + 1 }}</td>
              <td class="table321">
                {{ moment(max1['时间']).format('YYYY-MM-DD HH:mm:ss') }}
              </td>
              <td class="table321">
                {{ Number(max1['风速']).toFixed(1) }}
              </td>
              <td class="table321">
                {{ Number(max1['风向']).toFixed(1) }}
              </td>
              <td class="table321">
                {{ Number(max1['1/3波高']).toFixed(2) }}
              </td>
              <td class="table321">
                {{ Number(max1['1/3波周期']).toFixed(1) }}
              </td>
              <td class="table321">
                {{ Number(max1['波向']).toFixed(1) }}
              </td>
            </tr>
          </table>
        </div>
        <!-- 修改版 end -->

        <!-- 时间波向部分 -->
        <div class="table67">
          <div class="table6">
            <div class="shijian">{{ $t('detail.时间3') }}</div>
            <div class="table6time">
              <div class="time1">{{ newtimert }}</div>
            </div>
          </div>

          <div class="table7">
            <div class="boxiang">{{ $t('detail.波向') }}</div>
            <div class="table7btm">
              <div class="btmcircle1">
                <div class="btmcircle2" :style="{ transform: 'rotate(' + bxright + 'deg)' }">
                  <div class="jiantou2"></div>
                </div>
                <div class="wordbx">{{ bxright }}°</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import '../assets/rem'
// 导入接口：
import { bigfloater2 } from '../service/getData'
const echarts = require('echarts')
import windLevel from './wind'
let intervalID
export default {
  data() {
    return {
      configList: null,
      listeqdata: {},
      listchart: null,
      windLevel: windLevel,
      equipid: null,
      // 通过query 传递的 equipid
      boxiangList: null,
      boxiangCount: 0,
      value1: [
        //格式化选择的开始时间，当前时间的一年前
        moment()
          .subtract(1, 'month')
          .format('YYYY-MM-DD 00:00:00'),
        //选择的当前时间
        moment(moment()).format('YYYY-MM-DD 00:00:00')
      ],
      moment: moment,
      showchart: true,
      listrev: null,
      bxright: null,
      fx: null,
      fxleft: null,
      fs: null,
      fxnote: null,
      title3time: null,
      number: 1000,
      listJd: null,
      zdfs: null,
      zdfx: null,
      zdbg: null,
      zdbzq: null,
      zdbx: null,
      newtimert: null,
      toptimebegin: null,
      bdt:
        null ||
        moment()
          .subtract(1, 'month')
          .format('YYYY-MM-DD 00:00:00'),
      edt: null || moment().format('YYYY-MM-DD 00:00:00'),
      isActive: false,
      eqiyaStatus: true,
      ebogaoStatus: false,
      ewenduStatus: false,
      ebozouqiStatus: false,
      lang: "",
      isen: null,
    }
  },
  methods: {
    // 选择完时间点击确定后调用
    // time数组用来接收存放用户选择的时间
    // 如果time不为空，即用户选择了时间
    // 那么参数改变并传递给后台
    async selectTime(time) {
      if (time != null && time.length != 0) {
        this.bdt = time[0]
        this.edt = time[1]
      }
      await this.draw()
      await this.draw2()
    },

    async draw() {
      let middleChart = echarts.init(document.getElementById('middleChart'))
      let res3 = await bigfloater2(
        this.equipid,
        this.number,
        this.bdt,
        this.edt
      )
      let data = res3.data.AppendData.eqdata
      this.boxiangList = res3.data.AppendData
      this.boxiangCount = []
        .concat(
          this.boxiangList.eqboxiang1,
          this.boxiangList.eqboxiang2,
          this.boxiangList.eqboxiang3
        )
        .reduce((a, b) => {
          return a + b
        }, 0)
      let listJd = JSON.parse(data)
      let listjdDtl = listJd[0]
      this.listeqdata = listjdDtl

      let obj = []
      for (let i in listjdDtl) {
        obj.push(listjdDtl[i])
      }

      let fxcut = obj[15]
      this.fxleft = Number(fxcut).toFixed(0)
      let fengxiangcut = obj[15]
      this.fx = Number(fengxiangcut).toFixed(1)
      let fengsucut = obj[6]
      this.fs = Number(fengsucut).toFixed(1)

      this.title3time = moment(obj[1]).format('YYYY/MM/DD HH:mm:ss')
      let data2 = res3.data.AppendData.eqmax
      let listWind = JSON.parse(data2)
      let listwindDtl = listWind[0]

      let obj1 = []
      for (let i in listwindDtl) {
        obj1.push(listwindDtl[i])
      }
      // 根据下标找到值后渲染在页面中
      let zdfscut = obj1[0]
      this.zdfs = Number(zdfscut).toFixed(1)
      let zdfxcut = obj1[7]
      this.zdfx = Number(zdfxcut).toFixed(1)
      let zdbgcut = obj1[10]
      this.zdbg = Number(zdbgcut).toFixed(2)
      let zdbzqcut = obj1[4]
      this.zdbzq = Number(zdbzqcut).toFixed(1)
      let zdbxcut = obj1[5]
      this.zdbx = Number(zdbxcut).toFixed(1)
      let bxcut = obj1[5]
      this.bxright = Number(bxcut).toFixed(0)

      let data3 = res3.data.AppendData.eqhistory

      let data4 = res3.data.AppendData.eqparam

      let listchart = JSON.parse(data3)
      this.listchart = listchart
      this.listrev = this.listchart && this.listchart.reverse().slice(0, 5)

      var m = {}
      data4.map(item => {
        listchart &&
          listchart.map(data4 => {
            if (m[item.paramnm] instanceof Array) {
              console.log('')
            } else {
              m[item.paramnm] = []
            }
            m[item.paramnm].push([
              moment(data4['时间']).format('YYYY-MM-DD HH:mm:ss'),
              data4[item.paramnm]
            ])
          })
      })
      let mparamnm = []
      for (let a in m) {
        mparamnm.push(m[a])
      }

      let betime = []
      for (let i in listchart) {
        betime.push(listchart[i])
      }

      let benewtime = betime
      let righttime = []
      for (let c in benewtime[0]) {
        righttime.push(benewtime[0][c])
      }
      this.newtimert = moment(righttime[1]).format('YYYY-MM-DD HH:mm:ss')

      let topbgtime = benewtime[benewtime.length - 1]
      let topendtime = []
      for (let d in topbgtime) {
        topendtime.push(topbgtime[d])
      }
      this.toptimebegin = topendtime[1]
      // let name1 = this.$t('detail.气压1')
      let option = {
        legend: {
          left: '65%',
          textStyle: {
            color: 'rgba(169,169,169,1)',
            fontWeight: 500,
            fontFamily: 'NotoSansHans-Medium',
            fontSize: 10,
            lineHeight: 11
          },

          data: [
            {
              icon: 'circle',
              name: this.$t('detail.气压1')
            },
            {
              icon: 'circle',
              name: this.$t('detail.波高1')
            },
            {
              icon: 'circle',
              name: this.$t('detail.温度1')
            },
            {
              icon: 'circle',
              name: this.$t('detail.波周期1')
            }
          ],
          selected: JSON.parse(localStorage.getItem('userConfig'))
        },
        grid: {
          left: '8%',
          top: '12%',
          right: '2%'
          //bottom:'8%'
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: true
          },

          boundaryGap: false,
          nameTextStyle: {
            fontSize: 7,
            fontFamily: 'NotoSansHans-Medium',
            fontWeight: 500,
            color: 'rgba(150,150,150,1)'
          },
          splitNumber: 14
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          min: 'dataMin',
          splitLine: {
            // show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {
            showSymbol: false,
            name: this.$t('detail.气压1'),
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[1],
            lineStyle: {
              color: '#36CFC9',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#36CFC9'
            }
          },
          // 波高
          {
            showSymbol: false,
            name: this.$t('detail.波高1'),
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[10],
            lineStyle: {
              color: '#A26DEB',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#A26DEB'
            }
          },
          // 温度
          {
            showSymbol: false,
            name: this.$t('detail.温度1'),
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[3],
            lineStyle: {
              color: '#F759AB',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#F759AB'
            }
          },
          //波周期
          {
            showSymbol: false,
            name: this.$t('detail.波周期1'),
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#e0e7f7'
            },
            data: mparamnm[4],
            lineStyle: {
              color: '#FFF566',
              shadowColor: '#bdbdbd',
              shadowOffsetX: 5,
              shadowBlur: 10
            },
            itemStyle: {
              color: '#FFF566'
            }
          }
        ]
      }
      middleChart.setOption(option)
      // 图例开关的行为只会触发 legendselectchanged 事件
      middleChart.on('legendselectchanged', function (params) {
        localStorage.setItem('userConfig', JSON.stringify(params.selected))
        this.configList = params
      })
    },
    async draw2() {
      let _this = this
      let middleChart = echarts.init(document.getElementById('middleChart2'))
      let data = {
        x: [],
        d: []
      }
      let i = 0
      while (i < 16) {
        data.x.push(`${i * 22.5}`)
        data.d.push((Math.random() * 100) | 0)
        i++
      }
      middleChart.setOption({
        radiusAxis: {},
        polar: {},
        color: ['#467fff', '#FF7A45', '#FFF566'],
        title: {
          // text: '波向统计'
        },
        legend: {
          data: [this.$t('detail.波高0~1米'), this.$t('detail.波高1~2米'), this.$t('detail.波高2~3米')]
        },
        tooltip: {
          formatter: function (params) {
            return `
            24小时风向共 ${_this.listchart.length} 次，${params.name} ° 区域 ${params.value} 次
            `
          }
        },
        angleAxis: {
          type: 'category',
          data: data.x,
          z: 10
        },
        series: [
          // 风向
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang1,
            coordinateSystem: 'polar',
            name: this.$t('detail.波高0~1米'),
            stack: 'a'
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang2,
            coordinateSystem: 'polar',
            name: this.$t('detail.波高1~2米'),
            stack: 'a'
          },
          {
            type: 'bar',
            data: this.boxiangList.eqboxiang3,
            coordinateSystem: 'polar',
            name: this.$t('detail.波高2~3米'),
            stack: 'a'
          }
        ]
      })
    },

    // 风向玫瑰图
    async draw3() {
      let _this = this
      let middleChart = echarts.init(document.getElementById('middleChart3'))
      let data = {
        x: [],
        d: []
      }
      let i = 0
      while (i < 16) {
        data.x.push(`${i * 22.5}`)
        data.d.push((Math.random() * 100) | 0)
        i++
      }
      // this.wind_series_data()
      middleChart.setOption({
        radiusAxis: {},
        polar: {},
        color: [
          '#467fff',
          '#FF7A45',
          '#FFF566',
          '#e62f2f',
          '#6cf57d',
          '#9a249c',
          '#689c24',
          '#1a2465',
          '#b98941',
          '#798013',
          '#651380',
          '#bf4e82',
          '#631616',
          '#f56c6c',
          '#bdbf4e',
          '#456316'
        ],
        title: {
          // text: '波向统计'
        },
        grid: {
          x: 0,
          y: 0
        },
        legend: {
          right: -5,
          orient: 'vertical',
          data: _this.windLevel.map(n => n.name)
        },
        tooltip: {
          formatter: function (params) {
            console.log('params', params)
            return `
            24小时风向共 ${_this.listchart.length} 次，${params.name} ° 区域 ${params.seriesName} ${params.value} 次
            `
          }
        },
        angleAxis: {
          boundaryGap: false,
          type: 'category',
          data: data.x,
          z: 10
        },
        series: this.wind_series_data()
      })
    },
    // 风力风向数据
    wind_series_data() {
      let wind_level = {}
      for (let i = 0; i < 17; i++) {
        wind_level[i] = Array(17)
        wind_level[i].fill(null)
      }
      this.listchart&&this.listchart.map(w => {
        // 获取风力描述
        let wind = this.getLevel(w.风速)
        // debugger
        if (!(wind_level[wind.level][(w.风向 / 22.5) | 0] instanceof Array))
          wind_level[wind.level][(w.风向 / 22.5) | 0] = []
        wind_level[wind.level][(w.风向 / 22.5) | 0].push({
          ...wind,
          ...w
        })
      })
      let chartsData = Object.values(wind_level).map(w =>
        w.map(n => (n instanceof Array ? n.length : 0))
      )
      return chartsData.map((n, index) => ({
        type: 'bar',
        data: n,
        coordinateSystem: 'polar',
        name: this.windLevel.find(n => n.level === index).name,
        stack: 'a'
      }))
    },
    // 获取风力级别
    getLevel(speed) {
      // 解决 0.2987 => 0.2
      let sp = ((speed * 10) | 0) / 10
      let level = 0
      if ((sp >= 0) & (sp <= 0.2)) {
        level = 0
      } else if ((sp >= 0.3) & (sp <= 1.5)) {
        level = 1
      } else if ((sp >= 1.6) & (sp <= 3.3)) {
        level = 2
      } else if ((sp >= 3.4) & (sp <= 5.4)) {
        level = 3
      } else if ((sp >= 5.5) & (sp <= 7.9)) {
        level = 4
      } else if ((sp >= 8.0) & (sp <= 10.7)) {
        level = 5
      } else if ((sp >= 10.8) & (sp <= 13.8)) {
        level = 6
      } else if ((sp >= 13.9) & (sp <= 17.1)) {
        level = 7
      } else if ((sp >= 17.2) & (sp <= 20.7)) {
        level = 8
      } else if ((sp >= 20.8) & (sp <= 24.4)) {
        level = 9
      } else if ((sp >= 24.5) & (sp <= 28.4)) {
        level = 10
      } else if ((sp >= 28.5) & (sp <= 32.6)) {
        level = 11
      } else if ((sp >= 32.7) & (sp <= 36.9)) {
        level = 12
      } else if ((sp >= 37.0) & (sp <= 41.4)) {
        level = 13
      } else if ((sp >= 41.5) & (sp <= 46.1)) {
        level = 14
      } else {
        level = 15
      }

      return this.windLevel.find(n => n.level === level)
    }
  },
  created() {
    this.lang = localStorage.getItem('lang') || 'zh'
    console.log(this.lang)
    if (this.lang == 'zh') {
      this.isen = false
    }else{
      this.isen = true
    }
  },
  async mounted() {
    this.equipid = this.$route.query.equipid

    await this.draw()
    await this.draw2()
    await this.draw3()
    localStorage.clear()
    if (!localStorage.getItem('userConfig')) {
      let userConfig = {
        气压: this.eqiyaStatus,
        波高: this.ebogaoStatus,
        温度: this.ewenduStatus,
        波周期: this.ebozouqiStatus
      }
      this.configList = userConfig
      localStorage.setItem('userConfig', JSON.stringify(userConfig))
    }
    intervalID = setInterval(() => {
      this.draw()
    }, 6000)
  },
  destroyed() {
    clearInterval(intervalID)
  }
}
</script>

<style lang="scss" scoped>
.allsize {
  display: flex;
}

.leftsize {
  width: 4.2rem;
}

.rightsize {
  width: 9.46rem;
  margin-left: 0.65rem;
}

.active {
  border-radius: 1rem;
  border: 0.015rem solid rgba(255, 255, 255, 1);
  position: absolute;
  width: 0.57rem;
  height: 0.57rem;
  background: rgba(255, 255, 255, 1);
  margin-left: 0.46rem;
  margin-top: -0.57rem;
  z-index: 3;
}

.wordall {
  height: 100%;
  width: 100%;
}

.topone {
  width: 3.69rem;
  height: 0.62rem;
  background: rgba(92, 151, 253, 1);
  border-radius: 0.35rem 0rem 0.35rem 0rem;
  margin-left: 0.21rem;
  margin-top: 0.17rem;
}

.onetext {
  font-size: 0.25rem;
  font-weight: 500;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  line-height: 0.62rem;
  text-shadow: 0rem 0.01rem 0.06rem rgba(0, 0, 0, 0.3);
}

.toptwo {
  display: flex;
  margin-left: 0.34rem;
  margin-top: 0.15rem;
}

.toptwoa {
  display: flex;
  margin-left: 0.34rem;
  margin-top: 0.1rem;
}

.twosquare {
  //height: 0.6rem;
  //width: 1.1rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0rem 0.17rem 0rem rgba(203, 223, 254, 1);
  border-radius: 0.2rem;
  border: 0.02rem solid #cbdffe;
}

.twosquarehw {
  height: 0.6rem;
  width: 1.04rem;
}

.twosquare2 {
  // height: 0.6rem;
  //width: 1.1rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0rem 0.17rem 0rem rgba(203, 223, 254, 1);
  border-radius: 0.2rem;
  border: 0.02rem solid #cbdffe;
  margin-left: 0.1rem;
}

.words {
  //width: 0.78rem;
  height: 0.16rem;
  font-size: 0.15rem;
  font-family: NotoSansHans-Regular;
  font-weight: 400;
  color: rgba(92, 92, 92, 1);
  //margin-left: 0.16rem;
  margin-top: 0.08rem;
  line-height: 0.24rem;
  text-align: center;
}

.number {
  font-size: 0.15rem;
  font-family: NotoSansHans-Regular;
  font-weight: 550;
  color: rgba(38, 38, 38, 1);
  text-align: center;
  line-height: 0.35rem;
  //-webkit-font-smoothing:antialiased;
  //-webkit-font-smoothing:none;
}

.bottomword {
  width: 0.35rem;
  height: 0.17rem;
  font-size: 0.17rem;
  font-family: NotoSansHans-Regular;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 0.26rem;
  margin-left: 0.35rem;
  margin-top: 0.52rem;
}

.leftbtm2 {
  display: flex;
}

.bottomimg {
  width: 1.84rem;
  height: 1.84rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0.01rem 0.14rem 0rem rgba(203, 223, 254, 1);
  border: 0.03rem solid #cbdffe;
  border-radius: 1rem;
  z-index: 1;
  margin-left: 0.49rem;
}

.bgcolor {
  border-radius: 1rem;
  border: 0.015rem solid rgba(255, 255, 255, 1);
  position: absolute;
  width: 1rem;
  height: 1rem;
  background: linear-gradient(to right, #467fff, #64ffe4);
  margin-left: 0.42rem;
  margin-top: -0.93rem;
  z-index: 2;
}

.bgwhite {
  border-radius: 1rem;
  border: 0.015rem solid rgba(255, 255, 255, 1);
  position: absolute;
  width: 0.83rem;
  height: 0.83rem;
  background: rgba(255, 255, 255, 1);
  margin-left: 0.51rem;
  margin-top: -0.84rem;
  z-index: 3;
}

.jiantou {
  width: 0rem;
  height: 0rem;
  border-left: 0.5rem solid transparent;
  border-bottom: 1rem solid #457fff;
  border-right: 0.5rem solid transparent;
  border-width: 0rem 0.03rem 0.1rem 0.03rem;
  margin-left: 0.37rem;
}

.word98 {
  width: 0.45rem;
  height: 0.4rem;
  position: absolute;
  z-index: 4;
  font-size: 0.23rem;
  font-family: NotoSansHans-Bold;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.39rem;
  margin-left: 0.7rem;
  margin-top: -0.63rem;
  text-align: center;
}

.circle2 {
  position: relative;
  top: 0.27rem;
  left: 0.27rem;
  width: 1.3rem;
  height: 1.3rem;
}

.wordbtm {
  font-size: 0.36rem;
  font-family: NotoSansHans-Bold;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.54rem;
  text-align: center;
  margin-top: 0.7rem;
}

.btmrhtone {
  height: 0.78rem;
  width: 1.16rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0rem 0.15rem 0rem rgba(203, 223, 254, 1);
  border-radius: 0.15rem;
  border: 0.015rem solid #cbdffe;
  //margin-top: 45px;
  margin-left: 0.25rem;
}

.btmrhttwo {
  height: 0.78rem;
  width: 1.16rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0rem 0.1rem 0rem rgba(203, 223, 254, 1);
  border-radius: 0.15rem;
  border: 0.015rem solid #cbdffe;
  margin-top: 0.15rem;
  margin-left: 0.25rem;
}

.btmwordone {
  width: 0.78rem;
  height: 0.16rem;
  font-size: 0.15rem;
  font-family: NotoSansHans-Regular;
  font-weight: 400;
  text-align: center;
  color: rgba(92, 92, 92, 1);
  line-height: 0.24rem;
  margin-left: 0.22rem;
  margin-top: 0.13rem;
}

.btmwordtwo {
  height: 0.23rem;
  font-size: 0.2rem;
  font-family: NotoSansHans-Medium;
  font-weight: 550;
  color: rgba(38, 38, 38, 1);
  line-height: 0.35rem;
  text-align: center;
}

.righttop {
  display: flex;
}

.topicon {
  width: 0.3rem;
  height: 0.3rem;

  .icon {
    width: 0.36rem;
    height: 0.36rem;
    margin-top: 0.3rem;
  }
}

.toptime {
  width: 0.26rem;
  height: 0.13rem;
  font-size: 0.13rem;
  margin-left: 0.2rem;
  margin-top: 0.41rem;
  font-family: NotoSansHans-Regular;
  font-weight: 400;
  color: rgba(41, 41, 41, 1);
  line-height: 0.19rem;
}

.block {
  margin-left: 0.2rem;
  margin-top: 0.39rem;
  width: 3rem;
}

.el-date-editor--datetimerange.el-input__inner {
  width: 3.2rem;
}

.topnum {
  margin-left: 0.15rem;
  margin-top: 0.39rem;
  font-size: 0.17rem;
  font-family: NotoSansHans-Medium;
  font-weight: 550;
  color: rgba(41, 41, 41, 1);
  line-height: 0.26rem;
}

.topnumhx {
  margin-left: 0.15rem;
  font-size: 0.16rem;
  font-family: NotoSansHans-Medium;
  margin-top: 0.39rem;
  color: rgba(41, 41, 41, 1);
  line-height: 0.27rem;
}

.rightmiddle {
  height: 3.54rem;
  display: flex;
}

.middlenote {
  margin-top: 0.25rem;
  // margin-left: 0.3rem;
}

#middleChart {
  width: 100%;
  height: 3.25rem;
  margin-left: -0.8rem;
}

#middleChart2 {
  width: 35%;
  height: 3.25rem;
}

#middleChart3 {
  width: 4.05rem;
  height: 3rem;
  //padding-bottom: 0.1rem;
}

.rightbottom {
  display: flex;
  margin-bottom: 0.26rem;
}

.bgc {
  background: rgba(212, 232, 255, 0.8);
  font-size: 0.12rem;
  font-family: NotoSansHans-Medium;
  font-weight: 500;
  color: rgba(57, 68, 70, 1);
  line-height: 0.27rem;
  text-align: center;
}

.gc {
  font-size: 0.1rem;
  font-family: NotoSansHans-Bold;
  font-weight: bold;
  color: rgba(57, 68, 70, 1);
  line-height: 0.3rem;
}

.num3961 {
  font-size: 0.12rem;
  font-family: NotoSansHans-Medium;
  font-weight: 500;
  color: rgba(135, 135, 135, 1);
  line-height: 0.3rem;
  text-align: center;
  border-right: 0.02rem solid #dcdcdc;
}

.num3962 {
  font-size: 0.12rem;
  font-family: NotoSansHans-Medium;
  font-weight: 500;
  color: rgba(135, 135, 135, 1);
  line-height: 0.3rem;
  text-align: center;
  border-right: 0.02rem solid #dcdcdc;
  border-top: 0.02rem solid #dcdcdc;
}

.maxdata {
  width: 100%;
  height: 0.62rem;
  border-radius: 0.2rem;
  //border-radius: 0.2rem;
}

.space {
  white-space: nowrap;
}

.table30 {
  //border: 0.01rem solid #dcdcdc;
  height: 2.08rem;
  width: 100%;
  //margin-top: 0.1rem;
  border-collapse: collapse;
}

.table31 {
  background: rgba(212, 232, 255, 0.8);
}

.table311 {
  text-align: center;
  font-size: 0.1rem;
  font-family: NotoSansHans-Medium;
  font-weight: 500;
  color: rgba(57, 68, 70, 1);
  line-height: 0.25rem;
  //border-right: 0.01rem solid #dcdcdc;
  border-bottom: 0.01rem solid #dcdcdc;
}

.table301 {
  text-align: center;
  font-size: 0.1rem;
  font-weight: 500;
  color: rgba(57, 68, 70, 1);
  line-height: 0.25rem;
  vertical-align: top;
}

.table32 {
  width: 25%;
  border-right: 0.01rem solid #dcdcdc;
  border-bottom: 0.01rem solid #dcdcdc;
  text-align: center;
  font-size: 0.1rem;
  font-weight: 500;
  color: rgba(57, 68, 70, 1);
}

.table322 {
  width: 20%;
  //border-right: 0.01rem solid #dcdcdc;
  border-bottom: 0.01rem solid #dcdcdc;
  text-align: center;
  font-size: 0.12rem;
  color: rgba(135, 135, 135, 1);
  padding-top: 0.075rem;
  padding-bottom: 0.075rem;
}

.table321 {
  //width: 25%;
  white-space: nowrap;
  //border-right: 0.01rem solid #dcdcdc;
  border-bottom: 0.01rem solid #dcdcdc;
  text-align: center;
  font-size: 0.12rem;
  color: rgba(135, 135, 135, 1);
  padding-top: 0.075rem;
  padding-bottom: 0.075rem;
}

.topicon {
  width: 30px;
  height: 30px;

  .icon {
    width: 100%;
    height: 100%;
  }
}

.toptime {
  margin-left: 10px;
  font-size: 10px;
  font-weight: 400;
  color: rgba(41, 41, 41, 1);
  line-height: 29px;
}

.topnum {
  margin-left: 15px;
  font-size: 16px;
  font-weight: 550;
  color: rgba(41, 41, 41, 1);
  line-height: 27px;
}

.topnumhx {
  margin-left: 15px;
  font-size: 16px;
}

.table3212 {
  width: 20%;
  //border-right: 0.01rem solid #dcdcdc;
  border-bottom: 0.01rem solid #dcdcdc;
  text-align: center;
  font-size: 0.12rem;
  color: rgba(135, 135, 135, 1);
  padding-top: 0.075rem;
  padding-bottom: 0.075rem;
}

.title3 {
  display: flex;
  // border: 0.01rem solid #dcdcdc;
  height: 0.61rem;
  width: 3rem;
  margin-left: 0.05rem;
}

.title3all1 {
  width: 28%;
  height: 100%;
}

.title3all2 {
  width: 36%;
  height: 100%;
}

.title3word {
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(92, 92, 92, 1);
  line-height: 0.35rem;
  text-align: center;
  width: 12.5%;
}

.title24hleft {
  height: 0.31rem;
  font-size: 0.13rem;
  font-weight: bold;
  color: rgba(57, 68, 70, 1);
  line-height: 0.35rem;
  text-align: center;
  background: #d4e8ff;
}

.title24hleft2 {
  height: 0.25rem;
  font-size: 0.13rem;
  font-family: NotoSansHans-Bold;
  font-weight: bold;
  color: rgba(57, 68, 70, 1);
  padding-top: 0.02rem;
  text-align: center;
  background: #d4e8ff;
  line-height: 0.25rem;
}

.title24h {
  font-size: 0.13rem;
  font-family: NotoSansHans-Bold;
  font-weight: bold;
  color: rgba(57, 68, 70, 1);
  margin-top: 0.02rem;

  text-align: center;
}

.title3word1 {
  font-size: 0.12rem;
  font-family: NotoSansHans-Regular;
  font-weight: 400;
  color: rgba(92, 92, 92, 1);
  line-height: 0.35rem;

  text-align: center;
}

.title24h1 {
  font-size: 0.13rem;
  font-family: NotoSansHans-Bold;
  font-weight: bold;
  color: rgba(57, 68, 70, 1);
  margin-top: -0.05rem;

  text-align: center;
}

.table34 {
  width: 6.88rem;
  height: 3.25rem;
  margin-left: -0.5rem;
  border-radius: 0.2rem;
  border: 0.02rem solid rgba(145, 181, 235, 0.894);
}

.title4all1 {
  width: 16%;
  height: 100%;
}

.title4all {
  width: 21%;
  height: 100%;
}

.flexbox {
  display: flex;
}

.table3top {
  margin-top: 0.13rem;
}

.title4 {
  display: flex;
  //border: 0.01rem solid #dcdcdc;
  height: 0.61rem;
  width: 3.88rem;
}

.title24h2 {
  font-size: 0.13rem;
  font-family: NotoSansHans-Bold;
  font-weight: bold;
  color: rgba(57, 68, 70, 1);
  line-height: 0.3rem;
  margin-left: 0.1rem;
}

.table41 {
  background: rgba(212, 232, 255, 0.8);
  height: 10%;
}

.table40 {
  //border: 0.01rem solid #dcdcdc;
  height: 2.31rem;
  width: 3rem;
  margin-top: 0.1rem;
  border-collapse: collapse;
}

.table6 {
  margin-left: 0.4rem;
  margin-top: 0.2rem;
}

.table6time {
  height: 0.78rem;
  width: 1.16rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0rem 0.17rem 0rem rgba(203, 223, 254, 1);
  border-radius: 0.2rem;
  border: 0.03rem solid #cbdffe;
  margin-top: 0.1rem;
  margin-left: 0.2rem;
}

.shijian {
  text-align: center;
  font-size: 0.17rem;
  font-family: NotoSansHans-Medium;
  font-weight: 550;
  color: rgba(0, 0, 0, 1);
  line-height: 0.27rem;
  margin-left: 0.2rem;
}

.time1 {
  text-align: center;
  font-size: 0.17rem;
  font-family: NotoSansHans-Regular;
  font-weight: 550;
  color: #394446;
  line-height: 0.2rem;
  margin-top: 0.17rem;
}

.time2 {
  font-size: 0.2rem;
  text-align: center;
  font-family: NotoSansHans-Medium;
  font-weight: 550;
  color: rgba(38, 38, 38, 1);
  line-height: 0.1rem;
}

.boxiang {
  text-align: center;
  font-size: 0.17rem;
  font-family: NotoSansHans-Medium;
  font-weight: 550;
  color: rgba(0, 0, 0, 1);
  line-height: 0.27rem;
  margin-left: 0.2rem;
}

.table7 {
  margin-left: 0.4rem;
  margin-top: 0.15rem;
}

.table7btm {
  width: 1.05rem;
  height: 1.05rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0.02rem 0.1rem 0rem rgba(203, 223, 254, 1);
  border: 0.02rem solid #cbdffe;
  border-radius: 1rem;
  margin-top: 0.09rem;
  margin-left: 0.2rem;
}

.btmcircle1 {
  width: 0.8rem;
  height: 0.8rem;
  background: linear-gradient(to right, #467fff, #64ffe4);
  border: 0.02rem solid rgba(255, 255, 255, 1);
  border-radius: 1rem;
  margin-left: 0.1rem;
  margin-top: 0.1rem;
  position: relative;
}

.btmcircle2 {
  width: 0.65rem;
  height: 0.65rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 1rem;
  margin-left: 0.08rem;
  margin-top: 0.08rem;
  position: absolute;
  z-index: 1;
}

.wordbx {
  width: 0.3rem;
  height: 0.3rem;
  position: absolute;
  z-index: 4;
  font-size: 0.15rem;
  font-family: NotoSansHans-Bold;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.54rem;
  margin-left: 0.27rem;
  margin-top: 0.15rem;
  text-align: center;
}

.jiantou2 {
  width: 0rem;
  height: 0rem;
  border-left: 0.5rem solid transparent;
  border-bottom: 1rem solid #457fff;
  border-right: 0.5rem solid transparent;
  border-width: 0rem 0.03rem 0.1rem 0.03rem;
  margin-left: 0.3rem;
  // margin-top: 5px;
}
.activeen1{
  font-size: 0.18rem;
}
.activeen2{
  font-size: 0.12rem;
  line-height: 0.1rem;
}
.activeen3{
  font-size: 0.12rem;
  line-height: 0.1rem;
  white-space: normal;
}

</style>
